
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {BreadCrumbAndDataHelperService} from './bread-crumb-and-data-helper.service';

export abstract class BreadCrumbAndDataResolverService<T> implements Resolve<T> {


  constructor(private helper: BreadCrumbAndDataHelperService) {}

  public abstract async getData(route: ActivatedRouteSnapshot): Promise<T>;
  public abstract getName(data: T): string;

  async resolve(route: ActivatedRouteSnapshot): Promise<T> {
    this.helper.showLoader();
    const data = await this.getData(route);
    const name = this.getName(data);
    const fullUrl = this.helper.breadCrumbService.createRootUrl(route);
    this.helper.breadCrumbService.prepareBreadCrumb(fullUrl, name);
    return data;
  }
}





// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/route-resolvers/bread-crumb-and-data-resolver.service.ts